<!-- PageLoader Start Here -->
<div id="pageLoader" class="loading-container">
  <div class="pulse"></div>
</div>
<!-- Spinner loader starts here -->
<div *ngIf="loading">
  <div class="spinner-loading-container">
    <div class="spinner-pulse"></div>
  </div>
</div>
<!-- Spinner loader ends here -->
<!-- Top Left BG Start Here -->
<div class="topLeftCornerBG"></div>
<!-- Bottom Right BG Start Here -->
<div class="bottomRightCornerBG"></div>
<!-- Nav (Menu Section) Start Here -->
<header id="hdr_sec" *ngIf="isUserLoggedIn==true || isPublicPage">
  <div class="logo-sec-cls">
    <a href="javascript:void(0);" [routerLink]="[landingUrl?landingUrl:'']" alt="">
      <img src="./assets/images/logo.png" />
    </a>
  </div>
  <div [menu-navigation] class="menuIconCls">
    <span>
      <!-- Menu -->
    </span>
  </div>
  <!-- Menus for Candidate -->
  <div class="left-nav-sec" *ngIf="leftMenuList && leftMenuList.menuType=='menu'">
    <ul class="menu-list">
      <li *ngFor="let menu of leftMenuList.menusList">
        <a [menu-navigation]="{menuData: menu, txnStatus : txnStatus}" href="javascript:void(0);" alt="">
          <img [src]="menu.menuIconUrl" *ngIf="menu.menuIconUrl"/>
          <span>{{ menu.text }}</span>
        </a>
      </li>
    </ul>
  </div>
  <!-- Group & Menus for Admin -->
  <div class="left-nav-sec" *ngIf="leftMenuList && leftMenuList.menuType=='group'">
    <ul class="menu-list">
      <li class="menu-group {{ group.type=='group'?'custom-caret':'' }}" *ngFor="let group of leftMenuList.groups">
        <a [menu-navigation]="{menuData: group, txnStatus : txnStatus}" href="javascript:void(0);" alt="">
          <p class="firstLevelMenu">
            <img [src]="group.groupMenuIconUrl" />
            <span>{{ group.groupText }}</span>
          </p>
          <div class="subMenuSec">
            <div class="submenu-item" *ngFor="let menu of group.menusList">
              <a [menu-navigation]="{menuData: menu, txnStatus : txnStatus}" href="javascript:void(0);" alt="">
                <span>{{ menu.text }}</span>
              </a>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
  <div class="logoutProfileMobile">
    <a href="javascript:void(0);" mdTooltip="Logout" class="" (click)="logout()">
      <img src="./assets/images/logout_header_w.png">
      <span>Logout</span>
    </a>
  </div>
</header>
<!-- Top Right Profile Section Start Here -->
<section class="fullWidthCls topHeaderSecCls" *ngIf="isUserLoggedIn==true || isPublicPage">
  <div class="shadow-band" *ngIf="_utility.showGradientBandAtTop"></div>
  <div class="topLeftHeaderSec" *ngIf="isUserLoggedIn==true && panelModel.showChildPageHeader>0 && !isPublicPage">
    <ul [ngClass]="topleftHeader">
      <li *ngIf="!_utility.usesVirtualLocation(_appGlobals.selectedExamModel)">
        <a (click)="clickOnLocateCenter()" [class]="panelModel.showChildPageHeader==1?'activePageHighlighter':''" href="javascript:void(0);"
          alt="">Locate Center</a>
      </li>
      <li *ngIf="panelModel.showChildPageHeader==2">
        <a [class]="panelModel.showChildPageHeader==2?'activePageHighlighter':''" alt="">Schedule and Reserve</a>
      </li>
    </ul>
  </div>
  <div class="topRightHeaderSec">
    <div>
      <ul class="topRightHeaderConCls">
        <li *ngIf="isCandidate || isPublicPage" class="termsConditionDesktop">
          <div class="policy-div">
            <a href="https://www.redhat.com/en/about/privacy-policy" target="_blank">Privacy statement</a>
            <span class="sepratorPrivacy"></span>
            <a href="https://www.redhat.com/en/about/red-hat-training-policies" target="_blank">Terms of use</a>
          </div>
        </li>
           <!-- Start Switch A/c type -->
        <li *ngIf="canSwitch==true">
          <div class="changeAccountType">
            <a href="javascript:void(0);" (click)="switchACType()" mdTooltip="{{ 'Switch a/c to '+ acTypeText }}">
              <i class="material-icons">&#xE8D4;</i>
              <span>{{ acTypeText }}</span>
            </a>
          </div>
        </li>
        <!-- End Switch A/c type -->
        <li *ngIf="!isPublicPage">
          <div class="usrProfileCls" mdTooltip="{{userRole}}">{{ panelModel.userInfo.firstName + ' ' + panelModel.userInfo.lastName }}
          </div>
        </li>
        <!-- Start Notification -->
        <li class="msgPopup" *ngIf="showNotification && !isPublicPage">
          <a class="bellIcon msgNotification" id="bellClapper" href="javascript:void(0);" (click)="toggle_class()" [mdTooltip]=showNotificationTooltip()>
            <i class="material-icons">&#xE7F4;</i>
            <sup *ngIf="notificationModel.count > 0">{{ notificationModel.count }}</sup>
          </a>
          <!-- Message Notification Drop Down -->
          <div id='overlayToogleFixed' [className]="_utility.toggle_my_Class" (click)="toggle_class()">
          </div>
          <div id='dropdown3' class='dropdown-content' [className]="_utility.toggle_my_Class" (click)="toggle_class()">
            <p *ngIf="isCandidate" class="msgNotificationSecTitle">
              <label class="noOfNotification">Notification
                <span class="btn-floating whiteBG">{{ notificationModel.count }}</span>
              </label>
            </p>
            <!-- Show notifications list only for candidate -->
            <div *ngIf="isCandidate" class="msgNotificationContainer">
              <ul class='msgNotDropDownContent'>
                <li *ngFor="let notification of notificationModel.list" class="{{ notification.isRead==true?'noLinkli':'' }}">
                  <a href="javascript:void(0);" class="{{ notification.isRead==true?'noLink':'' }}" (click)="openNotificationDetails(notification)">
                    <span class="msgType1 btn-floating lightSkyBG">
                      <i class="material-icons" *ngIf="notification.status == Enum.PendingStatusApprove">&#xE5CA;</i>
                      <i class=" material-icons" *ngIf="notification.status == Enum.PendingStatusReject">&#xE5CD;</i>
                      <i class="material-icons" *ngIf="notification.status == Enum.ExamUpcomingStatus">&#xE002;</i>
                      <i class="material-icons" *ngIf="notification.status == Enum.ExamExpiredStatus">&#xE14B;</i>
                    </span>
                    <p class="msg-content">
                      <span *ngIf="notification.isRead==false">
                        {{ notification.notificationMessage }}
                      </span>
                      <span *ngIf="notification.isRead==true">
                        {{ notification.notificationMessage }}
                      </span>
                      <!-- <small>1 Min ago</small> -->
                    </p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- End Notification -->
        <li>
          <div class="logoutProfile" *ngIf="!isPublicPage">
            <a href="javascript:void(0);" mdTooltip="Logout" class="" (click)="logout()">
              <img src="./assets/images/logout_header.png">
            </a>
          </div>
        </li>
      </ul>
    </div>
    <div *ngIf="isCandidate || isPublicPage" class="policy-div termsConditionMobile">
      <a href="https://www.redhat.com/en/about/privacy-policy" target="_blank">Privacy statement</a>
      <span class="sepratorPrivacy"></span>
      <a href="https://www.redhat.com/en/about/red-hat-training-policies" target="_blank">Terms of use</a>
    </div>

  </div>


</section>
<!-- Calling Component -->
<router-outlet (activate)='onActivate()'></router-outlet>
<footer *ngIf="isUserLoggedIn==true || isPublicPage">
</footer>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/panel-page/panel-page.component.html